import { PureComponent, PropsWithChildren } from "react";

export default class ValueEditorPropertyLabel extends PureComponent<PropsWithChildren> {
  render() {
    return (
      <div className="ct-value-editor__property-label">
        {this.props.children}
      </div>
    );
  }
}
